const HisCalendarSearch = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      stroke={strokeColor}
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 2v4"></path>
      <path d="M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25"></path>
      <path d="m22 22-1.875-1.875"></path>
      <path d="M3 10h18"></path>
      <path d="M8 2v4"></path>
      <circle cx="18" cy="18" r="3"></circle>
    </svg>
  );
};

export default HisCalendarSearch;
